import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import listensToClickOutside from 'react-onclickoutside';
import './style.css';

class HeaderDropDown extends Component {
  constructor() {
    super();
    this.state = {
      isOpened: false,
    };
    this.handleToggleDropDown = this.handleToggleDropDown.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleToggleDropDown() {
    this.setState({
      isOpened: !this.state.isOpened,
    });
    if (this.props.onVisibleChange) {
      this.props.onVisibleChange(!this.state.isOpened);
    }
  }

  handleClickOutside() {
    this.setState({
      isOpened: false,
    });
    if (this.props.onVisibleChange) {
      this.props.onVisibleChange(false);
    }
  }

  render() {
    const {
      isOpened,
    } = this.state;
    const {
      title,
      children,
    } = this.props;
    const dropdownClass = classNames({
      dropdown: true,
      open: this.state.isOpened,
    });

    return (
      <div className={dropdownClass}>
        <div onClick={this.handleToggleDropDown}>
          {title}
        </div>
        <ul className={`dropdown-menu apollo-header-menu ${isOpened ? 'visible' : ''}`}>
          {isOpened && children}
        </ul>
      </div>
    );
  }
}

HeaderDropDown.propTypes = {
  children: PropTypes.array.isRequired,
  title: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.object,
  ]),
  onVisibleChange: PropTypes.func,
};

export default listensToClickOutside(HeaderDropDown);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/Header/components/HeaderDropDown/index.js
 **/